// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"ContactsView_Wrapper__pb6hm","Image":"ContactsView_Image__186uU","Text":"ContactsView_Text__1Rn8W"};